import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
    getLocalParticipantId, getSortedLayoutParticipant, getSortedPinnedParticipantsByStatus, ParticipantView
} from '../../base/participants';
import { videoLayoutMode } from '../constants';

const SliderStyled = styled.div`
    display: grid;
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    grid-template-rows: repeat(
        ${props => props.rows},
        1fr
    );
    width: 100%;
    height: ${props => (props.maxPage > 1 ? 'calc(100% - 15px)' : '100%')};
`;
const PagingStyled = styled.div`
    width: 100%;
    height: 15px;
    display: flex;
    gap: 4px;

    .bar {
        width: ${props => props.width}%;
        height: 100%;
        margin: 0;
        margin-left: ${props => props.margin}%;
        background: #b3b3b3;
    }
`;

let touch_x = 0;
let touch_start = false;

function SliderFilm({
    localParticipantId,
    pinnedParticipants,
    participants,
    dominantSpeaker,
    mode,
    page,
    resize,
    setPage,
}) {
    const [columns, setColumns] = useState(1);
    const [rows, setRows] = useState(1);

    const [maxPage, setMaxPage] = useState(1);
    const [showParticipant, setShowParticipant] = useState(participants);
    const [isVertical, setIsVertical] = useState(false);

    useEffect(() => {
        changMode();

        if (window.orientation == 0) {
            setIsVertical(true);
        } else {
            setIsVertical(false);
        }
    }, []);

    const onTouchStart = e => {
        touch_start = true;
        touch_x = e.changedTouches[event.changedTouches.length - 1].clientX;
    };
    const onTouchEnd = e => {
        if (!touch_start) return;
        touch_start = false;
        const moveX = touch_x - e.changedTouches[event.changedTouches.length - 1].clientX;
        if (
            e.type == 'touchend' && (Math.abs(moveX) > 40)
        ) {
            if (moveX > 0) {
                if (page + 1 >= maxPage) return;
                setPage(page + 1);
                return;
            }
            if (page - 1 < 0) return;
            setPage(page - 1);
        }
    };

    useEffect(() => {
        if (window.innerWidth <= window.innerHeight) {
            setIsVertical(true);
        } else {
            setIsVertical(false);
        }
    }, [resize]);

    useEffect(() => {
        setPage(0);
    }, [mode]);

    useEffect(() => {
        const count = showParticipant.length;
        if (count <= 3) {
            setColumns(1);
            setRows(count);
        } else {
            const rows = Math.round(count / 2);
            setColumns(2);
            setRows(rows);
        }
    }, [showParticipant]);

    useEffect(() => {
        if (maxPage <= page) {
            setPage(page - 1);
            return;
        }
        changMode();
    }, [page, participants, isVertical, dominantSpeaker]);

    const changMode = () => {
        let list = new Array();
        let maxP = Math.ceil(participants.length / 8);

        if (mode === videoLayoutMode.pin || mode == videoLayoutMode.voice || mode == videoLayoutMode.seminar) {    
            const pinPage = Math.ceil(pinnedParticipants.length / 2) || 0;
            maxP = maxP + pinPage;

            if (mode == videoLayoutMode.voice) {
                maxP = maxP + (dominantSpeaker ? 1 : 0);
                if (page === 0 && dominantSpeaker) {
                    list.push(dominantSpeaker);
                    setMaxPage(maxP);
                    setShowParticipant(list);
                    return;
                } else {
                    page = dominantSpeaker ? page - 1 : page;
                }
            }

            if (page <= pinPage - 1) {
                list = [...pinnedParticipants].slice(2 * page, 2 * page + 2);
            } else {
                page = page - pinPage;
                list = participants.slice(8 * page, 8 * page + 8);
            }
        } else {
            list = participants.slice(8 * page, 8 * page + 8);
        }

        setMaxPage(maxP);
        setShowParticipant(list);
    };

    return (
        <>
            <SliderStyled
                onTouchStart={onTouchStart}
                onClick={onTouchEnd}
                onTouchEnd={onTouchEnd}
                columns={isVertical ? columns : rows}
                rows={isVertical ? rows : columns}
                maxPage={maxPage}>
                {showParticipant.map((participantId, index) => {
                    const isLocal = participantId === localParticipantId;

                    return (
                        <div
                            key={index}
                            className={`item item_${isLocal}`}
                            id={participantId}>
                            <ParticipantView participantId={participantId} />
                        </div>
                    );
                })}
            </SliderStyled>
            {maxPage > 1 && (
                <PagingStyled
                    width={100 / maxPage}
                    margin={(100 / maxPage) * page}>
                    <span className="bar"></span>
                </PagingStyled>
            )}
        </>
    );
}

function _mapStateToProps(state, ownProps) {
    const mode = ownProps.mode;
    let dominantSpeaker = null;
    let pinnedParticipants = new Array();
    // 나 자신 
    const localParticipantId = getLocalParticipantId(state);

    let includePin = mode === videoLayoutMode.pin || mode === videoLayoutMode.voice || mode === videoLayoutMode.seminar ? false : true;

    // 레이아웃에 보일 사용자 
    let participants = getSortedLayoutParticipant(state, includePin).map(p => p.user_uuid);

    // 핀 사용자 
    if (includePin === false) {
        pinnedParticipants = getSortedPinnedParticipantsByStatus(state, true).map(p => p.user_uuid);
    }

    if (mode === videoLayoutMode.voice) {
        dominantSpeaker = state['features/base/participants'].dominantSpeaker;
    } else if (mode === videoLayoutMode.seminar) {
        console.log(participants, pinnedParticipants);

        participants = [];
        pinnedParticipants = pinnedParticipants;
    }

    return {
        dominantSpeaker,
        pinnedParticipants,
        participants,
        localParticipantId
    }    
}

export default connect(_mapStateToProps)(SliderFilm);
